import React, { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import FormView from "./FormView";
import { showDialog } from "../../appRedux/actions/common";
import { clearMentorInfo } from "../../appRedux/actions/mentors";
import DialogModal from "../Common/DialogModal";

function AddInfo() {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const { dialog } = useSelector((state) => ({
    dialog: state.common.dialog,
  }));

  useEffect(() => {
    if (!dialog) {
      setOpen(false);
    }
  }, [dialog]);

  const handleOpen = () => {
    setOpen(true);
    dispatch(clearMentorInfo());
    dispatch(
      showDialog({
        title: "Onboard New Mentor",
        size: "xl",
        id: "mentor_add",
      })
    );
  };

  return (
    <Fragment>
      <button className="btn add-btn m-r-5" onClick={handleOpen}>
        <i className="fa fa-plus mr-1" /> Add Mentor
      </button>
      {open && (
        <DialogModal
          infoId="mentor_add"
          bodyView={<FormView isUpdate={false} key="add_mentor_form" />}
        />
      )}
    </Fragment>
  );
}

export default AddInfo;
